if (typeof document === "undefined") return;
var createStylesheet = function(chunkId, fullhref, oldTag, resolve, reject) {
	var linkTag = document.createElement("link");

	linkTag.rel = "stylesheet";
	linkTag.type = "text/css";
	if (__webpack_require__.nc) {
		linkTag.nonce = __webpack_require__.nc;
	}
	var onLinkComplete = function(event) {
		// avoid mem leaks.
		linkTag.onerror = linkTag.onload = null;
		if (event.type === 'load') {
			resolve();
		} else {
			var errorType = event && event.type;
			var realHref = event && event.target && event.target.href || fullhref;
			var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + errorType + ": " + realHref + ")");
			err.name = "ChunkLoadError";
			err.code = "CSS_CHUNK_LOAD_FAILED";
			err.type = errorType;
			err.request = realHref;
			if (linkTag.parentNode) linkTag.parentNode.removeChild(linkTag)
			reject(err);
		}
	}
	linkTag.onerror = linkTag.onload = onLinkComplete;
	linkTag.href = fullhref;


	if (oldTag) {
		oldTag.parentNode.insertBefore(linkTag, oldTag.nextSibling);
	} else {
		document.head.appendChild(linkTag);
	}
	return linkTag;
};
var findStylesheet = function(href, fullhref) {
	var existingLinkTags = document.getElementsByTagName("link");
	for(var i = 0; i < existingLinkTags.length; i++) {
		var tag = existingLinkTags[i];
		var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
		if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return tag;
	}
	var existingStyleTags = document.getElementsByTagName("style");
	for(var i = 0; i < existingStyleTags.length; i++) {
		var tag = existingStyleTags[i];
		var dataHref = tag.getAttribute("data-href");
		if(dataHref === href || dataHref === fullhref) return tag;
	}
};
var loadStylesheet = function(chunkId) {
	return new Promise(function(resolve, reject) {
		var href = __webpack_require__.miniCssF(chunkId);
		var fullhref = __webpack_require__.p + href;
		if(findStylesheet(href, fullhref)) return resolve();
		createStylesheet(chunkId, fullhref, null, resolve, reject);
	});
}
// object to store loaded CSS chunks
var installedCssChunks = {
	"common-es6-components": 0
};

__webpack_require__.f.miniCss = function(chunkId, promises) {
	var cssChunks = {"spa-assets/on-demand/homepage-business-business-engagement-banner-module-styles":1,"spa-assets/on-demand/homepage-business-customization-module-styles":1,"spa-assets/on-demand/homepage-business-education-thought-leadership-module-styles":1,"spa-assets/on-demand/homepage-business-meet-a-specialist-module-styles":1,"spa-assets/on-demand/homepage-business-financial-center-banker-finder-module-styles":1,"spa-assets/on-demand/homepage-business-icon-grid-module-styles":1,"spa-assets/on-demand/homepage-business-industry-module-styles":1,"spa-assets/on-demand/homepage-business-marketing-module-styles":1,"spa-assets/on-demand/homepage-business-product-and-article-picker-module-styles":1,"spa-assets/on-demand/homepage-business-product-promotion-module-styles":1,"spa-assets/on-demand/homepage-business-solution-capabilities-module-styles":1,"spa-assets/on-demand/homepage-business-solution-finder-module-styles":1,"spa-assets/on-demand/homepage-business-storyblock-module-styles":1,"spa-assets/on-demand/homepage-business-tools-and-insights-module-styles":1,"spa-assets/on-demand/homepage-business-wayfinding-module-styles":1};
	if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
	else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
		promises.push(installedCssChunks[chunkId] = loadStylesheet(chunkId).then(function() {
			installedCssChunks[chunkId] = 0;
		}, function(e) {
			delete installedCssChunks[chunkId];
			throw e;
		}));
	}
};

// no hmr

// no prefetching

// no preloaded